function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#F2F2F2;}\r\n\t.st1{fill:none;stroke:#5185EC;stroke-miterlimit:10;}\r\n\t.st2{fill:#5185EC;stroke:#5185EC;stroke-miterlimit:10;}\r\n\t.st3{fill:#202124;}\r\n\t.st4{fill:#EB506E;}\r\n\t.st5{fill:#B1CEFC;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:#F7CD5B;}\r\n\t.st8{fill:#040844;}\r\n\t.st9{fill:#FFFFFF;}\r\n\t.st10{fill:#5492ED;}\r\n\t.st11{fill:#FFFFFF;stroke:#202124;stroke-width:0.75;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "tab"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "121.9,0.4 125.5,232.9 455.5,282.6 469.1,20.1  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 138.5,
  y1: 68.6,
  x2: 222.1,
  y2: 76.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 137.2,
  y1: 81.5,
  x2: 220.8,
  y2: 89.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 136.6,
  y1: 94.6,
  x2: 214.3,
  y2: 102.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 437.1,
  cy: 38.3,
  r: 10.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M192,35.1c1.9,0,1.9-3,0-3C190.1,32.1,190.1,35.1,192,35.1L192,35.1z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M359.9,61.6c30.9,2.6,61.7,5.2,92.6,7.8c0.5,0,0.5-0.7,0-0.8c-30.9-2.6-61.7-5.2-92.6-7.8 C359.4,60.8,359.4,61.5,359.9,61.6L359.9,61.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M353.1,72.9c22.3,2,44.6,4.1,66.9,6.1c0.5,0,0.5-0.7,0-0.8c-22.3-2-44.6-4.1-66.9-6.1 C352.6,72.1,352.6,72.8,353.1,72.9L353.1,72.9z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M370.2,86.2c26.3,2.7,52.6,5.4,78.8,8.1c0.5,0,0.5-0.7,0-0.8c-26.3-2.7-52.6-5.4-78.8-8.1 C369.8,85.4,369.8,86.1,370.2,86.2L370.2,86.2z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M131.1,230c4.4-0.1,8.8,0.6,13,1.9c0.5,0.1,0.7-0.6,0.2-0.7c-4.3-1.4-8.7-2-13.2-1.9 C130.6,229.2,130.6,230,131.1,230L131.1,230z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M152.6,233.5c8.6,0.4,17.1,1.6,25.5,3.5c0.5,0.1,0.7-0.6,0.2-0.7c-8.5-1.9-17-3.1-25.7-3.6 C152.1,232.7,152.1,233.5,152.6,233.5L152.6,233.5z"
}))), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "236.8,49 133,40.4 133,12.1 236.8,20.7  "
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "guy"
}, /*#__PURE__*/React.createElement("g", {
  id: "legs"
}, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M247.3,232.9c-0.3,6.1-0.7,12.2-1,18.3c8.3,1.1,16.5,2.2,24.8,3.3c23.2,3.1,46.2,6.2,69.1,9.5 c-0.1-6.6-0.7-11.9-1.2-15.6c-1-7.3-2.5-13-3.3-23.3c-0.1-1.4-0.2-2.5-0.2-3.3c-4.9,0.9-9.8,1.8-14.9,2.6 C295.2,228.7,270.7,231.4,247.3,232.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M335.7,225.4c1.5,12.8,3,25.7,4.5,38.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M246.8,233.6c-0.6,5.8-0.8,11.7-0.5,17.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M285.8,248.9c3.7,2.6,6.7,5.9,9.2,9.7c0.3,0.4,0.9,0,0.6-0.4c-2.5-3.9-5.7-7.2-9.4-9.9 C285.8,248,285.4,248.6,285.8,248.9L285.8,248.9z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "hand_right_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M213.5,242.2c-1.3,0.5-2.4,0.9-3.7,1.8c-1,0.7-3.4,2.3-4.8,5.5c-1.2,2.8-1,5.4-0.8,6.8 c0.2,2.1,0.3,3.5,1.3,4.8c2.6,3.5,8.3,2.7,8.9,2.6c0.8-0.1,3.8-0.6,6-3c1.7-1.8,1.7-3.4,2.6-5.2c1.1-2.2,3.4-5,9-7.1 c2.3,0.4,4.1,0,4.4-0.8c0.4-1.1-1.5-2.6-2-3.1c-0.9-0.8-3.2-2.4-7.3-2.5c-2-0.9-3.7-1.2-4.9-1.3 C218.6,240.2,215.7,241.3,213.5,242.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M228.5,90.5c-1.1,1.3-2.6,3.2-4,5.7c-2,3.5-3,6.5-3.8,9.4c-1.8,6-2.9,9.6-3.8,15.5 c-3.6,23.1-3.9,73.7-3.9,73.7c-0.1,7.1-0.1,18.3,0.9,33.1c0.4,6.2,0.9,11.3,1.3,14.7c0.9,0.3,2.1,0.6,3.5,0.7 c3.7,0.2,6.5-1.1,7.9-1.8c3.2-20.5,6.9-37.4,10-50.1c2.9-11.9,5.4-20.5,6.1-23c4.3-14.5,8.5-26.7,12-35.9c0.8-3.9,1.5-10.1-0.5-17 C249,97.7,230.7,91.2,228.5,90.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M226.6,92.3c-10.9,19.7-11.9,43.2-12.7,65.8c-0.9,27.9-1.8,56,1.2,83.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M253.1,135.9c-12.1,34.3-21,69.6-26.6,105.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M215.1,242.6c3,1,6.3,1,9.3,0"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M214.1,241.9c-2.6,0.9-5,2.2-7.1,4"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M227.1,242.6c3.5-0.7,7.1,1.1,8.6,4.3c0.2,0.4,0.9,0.1,0.6-0.4c-1.7-3.6-5.6-5.4-9.4-4.7 C226.4,242,226.6,242.7,227.1,242.6L227.1,242.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M231.2,248.3c-2.7,1.9-5.3,3.8-7.5,6.3s-3.7,5.6-3.7,8.9"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M206.5,246.5c-2.7,4.3-3.1,10-0.9,14.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M209.8,249.1c-2.2,4.5-1.7,9.7,1.3,13.7c0.3,0.4,0.9,0,0.6-0.4c-2.8-3.8-3.3-8.6-1.3-12.9 C210.6,249.1,210,248.7,209.8,249.1L209.8,249.1z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M214.1,250.6c-1.2,4.4-2.2,9.5,1.6,12.9c0.4,0.3,0.9-0.2,0.5-0.5c-3.6-3.2-2.5-8.1-1.4-12.2 C214.9,250.3,214.2,250.1,214.1,250.6L214.1,250.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M219.2,252c-1.8,3.1-2.2,6.6-1.2,10c0.1,0.5,0.9,0.3,0.7-0.2c-1-3.2-0.6-6.5,1.1-9.4 C220.1,252,219.5,251.6,219.2,252L219.2,252z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "torso_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M228.5,90.5c-0.9,3.1-2,7.6-2.6,13.1c-0.9,8.1-0.3,14.5,0.5,20.6c1.5,12,2.3,18,5,28.5 c3.4,13.3,8.3,36.7,15.7,80.4c2,0.9,4.9,2,8.5,3.1c16.6,5.2,31,4.5,38,3.8c20.1-2.1,34.8-10.1,42.2-14.9 c-1.5-23.4-2.5-47.7-3-72.8c-0.3-16.8-0.3-33.3-0.1-49.3c-2.9-2.9-7.1-6.7-12.6-10.4c-2.6-1.7-13.9-8.9-30.7-11.7 c-17.8-3-32,0.5-41.4,2.9C239.7,85.8,233.1,88.4,228.5,90.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M225.8,120.5c6.2,37.6,13.4,75.1,21.4,112.4"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M247.1,233.1c28.4,12.1,62.7,9.2,88.7-7.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M228.5,90.5c15.9-6.9,33.2-11.2,50.6-10.6c17.4,0.6,34.8,6.5,47.8,18"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M332,108.1c-0.2,39,0.9,78,3.3,117c0,0.5,0.8,0.5,0.8,0c-2.4-39-3.5-78-3.3-117 C332.8,107.6,332,107.6,332,108.1L332,108.1z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "hand_left_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M271.4,246.5c-1.3-0.2-3.1-0.3-5.2-0.2c-2.1,0.1-6,0.4-10,2.5c-2.7,1.4-7.3,4.6-6.7,6.5 c0.1,0.3,0.7,1.7,6.2,1.7c-3,4.8-6.1,7.4-8.5,8.9c-1.6,1-3.2,1.7-3.2,2.8c0,1.8,3.9,3.1,6.6,4.1c2.4,0.8,4.9,1.7,8.4,1.5 c1.4-0.1,3.7-0.4,6.3-1.4c0.6-0.2,3.1-1.4,5.9-3.9c2.3-2.1,2.1-2.9,5.9-8.3c3.2-4.6,4.1-5.1,4.1-6.9c0-2.7-2.2-5.3-4.6-6.5 C274.4,246.1,272.3,246.4,271.4,246.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M327.9,99c1,0.7,1.7,1.9,3.2,4.3c3.1,5.1,4.3,9.6,4.7,11.2c3.2,12.5,4.8,18.8,6.1,26.2 c2.7,16.1,0.8,12.1,3.3,30c0.5,3.3,1.3,8.6-0.4,14.9c-1,3.8-2.5,6.5-3.5,8.3c-3.7,6.7-8.2,10.8-9.7,12.3 c-9.9,9.4,1.3,0.7-28.5,29.9c-5.8,5.7-13.3,13-22.3,21.5c-0.3-1.3-0.8-2.8-1.8-4.5c-2.4-3.9-5.8-5.8-7.5-6.6 c2.4-3.6,4.8-7.3,7.2-11c12.5-19.6,22.8-39,31.4-57.7c-0.5-4-1.1-8-1.7-12c-2.4-17.6-4.9-35.1-7.5-52.5 C302.3,112,321.3,94.5,327.9,99z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M300.2,113.3c3.7,21.6,6.8,43.3,9.3,65.1c0.1,0.5,0.8,0.5,0.8,0c-2.5-21.9-5.6-43.6-9.3-65.3 C300.9,112.6,300.2,112.8,300.2,113.3L300.2,113.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M310.1,177.1c-12,23.6-25,46.7-39,69.2c-0.3,0.4,0.4,0.8,0.6,0.4c14-22.5,27-45.6,39-69.2 C311,177,310.3,176.6,310.1,177.1L310.1,177.1z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M271.7,247.3c4.3,1.4,7.3,5.1,7.8,9.6c0.1,0.5,0.8,0.5,0.8,0c-0.5-4.8-3.8-8.8-8.4-10.3 C271.5,246.4,271.3,247.1,271.7,247.3L271.7,247.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M328.2,100.5c5.5,5.7,7.3,13.9,9.2,21.3c1.9,7.3,3.4,14.6,4.6,22c1.3,8,2.2,16,2.7,24.1 c0.5,8,1.2,16.3-2.6,23.7c-3.5,6.7-9,12.3-14,17.9c-5,5.6-10.1,11-15.4,16.3c-10.5,10.7-21.3,21-32.2,31.4 c-0.4,0.3,0.2,0.9,0.5,0.5c12.2-11.6,24.4-23.2,36.1-35.4c5.8-6.1,11.5-12.3,17-18.6c4.2-4.9,8.6-10.1,10.6-16.5 c2-6.7,1.1-14.4,0.6-21.3c-0.6-8.1-1.5-16.2-2.9-24.3c-1.4-8-3.1-15.9-5.3-23.8c-1.8-6.5-3.6-13.1-8.4-18 C328.4,99.6,327.8,100.2,328.2,100.5L328.2,100.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M250,254.4c4.2-6,12.1-9.2,19.2-7.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M257.9,252.7c-3.1,5.9-8,10.2-12.9,14.5c-0.4,0.3,0.2,0.8,0.5,0.5c5-4.3,9.9-8.8,13-14.7 C258.8,252.7,258.1,252.3,257.9,252.7L257.9,252.7z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M245.6,269.2c4.6-0.8,8.8-2.7,12.6-5.6c0.4-0.3-0.2-0.8-0.5-0.5c-3.6,2.8-7.7,4.6-12.2,5.4 C244.9,268.5,245.1,269.2,245.6,269.2L245.6,269.2z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M249.2,270c2.3,0.8,4.4-0.1,6.6-1c2.4-1,4.8-2.2,6.8-3.9c0.4-0.3-0.2-0.8-0.5-0.5c-2.9,2.4-8.8,6-12.6,4.7 C249,269.2,248.8,269.9,249.2,270L249.2,270z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M253.4,272.2c3.6,0.4,7.1-0.4,10.2-2.3c0.4-0.3,0-0.9-0.4-0.6c-3,1.9-6.3,2.6-9.8,2.2 C252.9,271.4,252.9,272.1,253.4,272.2L253.4,272.2z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M257,274.2c5.9,0.5,11.9-2.1,15.6-6.7c0.8-1,1.5-2,2.1-3c1.6-2.5,3.3-5,4.9-7.5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "head_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M250.2,77.8c-0.2,1.2,0.1,3.6,0.1,4c0.1,0.9,0.3,3,1,4.9c1.7,4.8,5.8,7.3,6,7.5c4.2,2.5,8.4,1.9,9.5,1.7 c1.1,0.4,1.8,1,1.7,1.5c-0.1,0.5-1.2,1.1-2.7,0.9c-0.1,0.2-0.7,2,0.3,3.6c0.9,1.5,2.7,1.9,4,1.7c1.1-0.2,1.9-1,3.5-2.7 c1.2-1.2,2.2-2.3,3.2-4c0.9-1.6,1.4-3.2,1.6-4.6c-0.8-1.2-1.6-2.4-2.4-3.5c0.3-1.1,0.7-2.7,0.9-4.6c0.3-2.5,0.6-4.5,0.2-6.2 c-1-4.3-5.9-6.6-6.9-7C262.1,67.4,251,73,250.2,77.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M277.4,83.2c0-0.9-0.1-3.6-2-6c-0.3-0.3-1.3-1.6-3.2-2.5c-2.7-1.3-5.3-1-6.8-0.8c-2.4,0.3-2.9,0.9-7.3,2.6 c-4.4,1.7-6.7,2.5-8.7,2.3c-0.6-0.1-4.6-0.5-7.2-3.9c-2.5-3.3-2.7-8.2-0.2-11.8c1.9-2.7,5-4.1,7.7-4.3c2.4-0.1,3.2,0.7,10.4,4.4 c6.2,3.1,9.2,4.6,10.4,5.1c2.8,1,5.2,1.7,7.3,4c0.7,0.7,1.7,1.9,2.1,3.6C280.8,79.6,277.8,82.8,277.4,83.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M250.6,78.4c-1.1,5.6,1.2,11.9,5.9,15.2s11.5,3.4,16.1-0.1c2.4-1.8,4.1-4.7,4.2-7.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M266.6,96.2c0.7,0.6,1.5,1.2,2.2,1.9c0.4,0.3,0.9-0.2,0.5-0.5c-0.7-0.6-1.5-1.2-2.2-1.9 C266.7,95.3,266.2,95.9,266.6,96.2L266.6,96.2z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M265.9,98.3c-0.8,1.5-0.2,3.6,1.3,4.5c0.9,0.5,2.1,0.5,3.1,0.2c1-0.3,1.9-0.9,2.8-1.5 c2.9-2.3,4.9-5.6,5.5-9.2"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M248.7,77.7c-3.9,0-6.9-3.9-7.4-7.8c-0.6-4.9,2.6-10.3,7.5-11.1c3-0.5,5.9,0.8,8.5,2.3 c2.5,1.6,4.8,3.6,7.5,4.9c3.3,1.7,7.1,2.2,10.4,4.1c3.2,1.8,5.9,5.7,4.6,9.1"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M248.4,77.4c3.1,1.2,6.6,0.3,9.7-1c3.1-1.2,6.2-2.8,9.5-2.8c2.6,0,5.1,0.9,7,2.7c1.9,1.8,2.9,4.4,2.8,6.9 c0.9-1.6,1.8-3.3,2.7-4.9"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M258.8,78c-1.1,2.7-3.4,9.7,1.2,10.5c0.5,0.1,0.7-0.6,0.2-0.7c-3.8-0.7-1.7-7.1-0.7-9.4 C259.6,78,259,77.6,258.8,78L258.8,78z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M264.5,81.3c-0.2-0.1,0.1-0.4,0.2,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.1c-0.4,0.1-0.1-0.6-0.2-0.6 C264.5,81.2,264.6,81.3,264.5,81.3c0,0.2,0.1,0.3,0.2,0.3c0,0.1,0,0.2,0,0.3c0,0,0-0.1,0-0.1c0.1-0.5-0.7-0.7-0.7-0.2 c-0.1,0.5,0.4,0.9,0.9,0.7c0.5-0.3,0.4-1,0.2-1.5c-0.2-0.5-0.9-0.8-1.3-0.2c-0.3,0.4-0.2,1.3,0.2,1.7c0.4,0.4,1,0.4,1.3,0 c0.3-0.4,0.2-1.3-0.1-1.7c-0.4-0.4-1-0.3-1.3,0c-0.4,0.4-0.2,1.1,0.3,1.4C264.6,82.3,264.9,81.6,264.5,81.3L264.5,81.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M263.6,77.5c0.8-0.3,1.6-0.2,2.3,0.2c0.4,0.3,0.8-0.4,0.4-0.6c-0.9-0.6-2-0.7-3-0.2 C262.8,77.1,263.2,77.7,263.6,77.5L263.6,77.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M259,91c2.3,0.9,4.7-0.1,5.8-2.2c0.2-0.4-0.4-0.8-0.6-0.4c-0.9,1.9-2.9,2.7-4.9,1.9 C258.8,90.1,258.6,90.8,259,91L259,91z"
})))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "magnifier"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M456.6,522.3l-154.5-53.9c-5.5-32.1-60.8-70.1-134.2-90c-83-22.4-157.8-13.1-167,21s50.7,79.8,133.7,102.2 c66.6,18,127.8,15.5,154.2-3.7c1.5,1,3.3,1.8,5.1,2.3l154.6,54c8.8,2.2,17.7-3.2,19.9-12S465.4,524.5,456.6,522.3z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2413 -0.9704 0.9704 0.2413 -313.1473 481.3733)",
  className: "st11",
  cx: 151.3,
  cy: 441,
  rx: 43.7,
  ry: 131.3
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "girl"
}, /*#__PURE__*/React.createElement("g", {
  id: "hand_left"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M233.8,272.7c1.2-1.7,2.9-4,5.3-6.5c0.8-0.8,3.6-3.6,7.9-6.5c5.5-3.6,7.7-3.6,8.8-3.5 c1.4,0.2,3.2,0.8,3.4,1.7c0,0.3-0.1,0.9-3,2.6c-2.7,1.5-4.4,2-5.9,2.6c-1.6,0.7-3.8,2-6,4.4c0.9,0.7,1.9,1.4,3,2 c3.1,1.9,6,3,8.5,3.8c-0.3,0.7-0.9,1.9-2,2.9c-1.1,1-2.3,1.4-4.6,2.1c-2.6,0.8-3.9,1.2-4.9,0.7c-1.5-0.7-1.5-2.2-2.6-3.6 C240.5,274.2,238.4,272.8,233.8,272.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M152.1,327.9c7.3-1.6,14.8-3.4,22.5-5.5c11.7-3.1,22.7-6.4,33.2-9.8c5.3-9.3,11.3-19.1,18.2-29 c2.8-4,5.5-7.8,8.3-11.5c1.4,0.3,4.3,1,6.9,3.5c1.4,1.4,2.3,2.8,2.8,3.8c-0.6,1.6-1.6,4.5-2.9,8c-4,11.3-9,22.2-12.2,33.7 c-0.9,3.3-1.7,6.5-4.4,9.9c-2.1,2.6-4.5,4.2-9.1,6.7c-6.3,3.5-9.4,5.2-14.3,7c-6.4,2.4-18.1,8.4-41.3,24.3c-2.1-1.7-3.7-3.5-5-5.2 C144.9,350.4,150.8,331.7,152.1,327.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M144.2,329.6c21.6-4.4,42.9-10,63.9-16.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M207.8,312.6c7.9-13.8,16.6-27.1,25.9-39.9"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M234.2,272.6c3.8,0.8,7,3,9.2,6.3c0.3,0.4,0.9,0,0.6-0.4c-2.2-3.4-5.6-5.8-9.6-6.6 C233.9,271.7,233.7,272.5,234.2,272.6L234.2,272.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M244.2,279.2c-5.8,15.7-11.6,31.3-17.3,47c-0.8,2.1-1.5,4.1-2.9,5.9c-1.8,2.3-4.3,3.7-6.9,5.1 C198,347.3,177.2,354.7,161,369"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M236.8,268.9c3.9-5.1,9.2-9.2,15.1-11.6c1.2-0.5,2.5-0.9,3.8-0.9c1.3,0,2.7,0.6,3.4,1.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M252,262.8c2.7-0.8,5.1-2.1,7.2-4c0.4-0.3-0.2-0.8-0.5-0.5c-2,1.8-4.3,3-6.9,3.8 C251.3,262.2,251.5,263,252,262.8L252,262.8z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M244.1,279.5c3.4-0.3,6.8-1.4,9.7-3.1"
}))), /*#__PURE__*/React.createElement("g", {
  id: "torso"
}, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M114.3,326.3c-1.6,2.7-3.8,6.6-6,11.5c-4,8.8-6.8,17.8-9.9,34.6c-2.1,11-4.3,23.2-5.6,40.6 c-1,14.2-1.5,33.1,0.6,55.3c9.9,3.9,20.6,7.6,32.2,11c22.9,6.7,44.1,10.6,62.8,12.8c0.6-10.3,1.2-18.7,1.6-24.1 c3.2-40.7,8.9-82.9,9.5-101.7c0.3-10.8,0.4-22,0.4-22c0-2.4,0-4.3,0-5.3c-3.6-2.3-8.4-5-14.4-7.6c-12.3-5.3-22.9-7.2-28.3-8 C139.2,320.9,124,323.6,114.3,326.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M114.4,326.6c27.7-7.6,57.5-3.7,82.2,10.9c0.4,0.2,0.8-0.4,0.4-0.6c-24.9-14.7-54.9-18.7-82.8-11 C113.8,326,113.9,326.7,114.4,326.6L114.4,326.6z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M199.9,340.1c0.4,46.1-5.3,91.9-11.1,137.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M113.9,326.8c-3.2,5.5-5.9,11.2-8,17.1c-1.7,4.7-3,9.5-4.3,14.3c-8.5,33.3-11.4,68-8.6,102.2"
}))), /*#__PURE__*/React.createElement("g", {
  id: "hand_right"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M275.1,444.1c1.2-0.8,1.5-0.3,3.7-1.1c4.9-1.7,5.4-4.6,9.5-5.2c1-0.1,2.5-0.4,3.5,0.6 c1.1,1.1,0.8,2.9,0.8,3.2c2,0.2,4.8,0.2,8-0.7c2.7-0.7,4-1.6,5-0.9c0.5,0.4,1,1.1,0.3,7.6c-0.6,6.3-1.2,7.4-2.2,8.3 c-0.9,0.8-1.8,1.1-3.8,1.7c-3.1,1-5.8,1.2-7.5,1.3c-2,0.1-6.6,0.1-12.3-1.6c-2.2-0.6-5.1-1.7-8.4-3.6 C271.7,450.2,272.2,445.9,275.1,444.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M197.8,338.8c2.5,1.7,4.1,4.8,7.2,10.9c2,4,3.2,7.2,3.8,9c2.5,7,5.8,13.7,8.7,20.5 c2.6,6.2,6.4,15.2,11.2,26.6c4.3,3.4,8.6,6.9,12.8,10.4c11.4,9.3,22.6,18.5,33.5,27.7c0.1,1.1,0,3-0.7,5.1c-0.8,2.5-2.2,4.1-3,5 c-4.2-1.8-10.2-4.1-17.5-6.2c-8.3-2.5-11.4-2.7-23.4-6.1c-11.5-3.3-14.8-4.8-17.9-6.6c-6.2-3.6-9.9-7.6-11.1-8.9 c-4-4.3-5.9-8.2-8-12.2c-7.5-14.2-6.7-10.5-14-24.7c-3.9-7.5-8.3-16.5-12.7-27c-0.5-2.6-0.8-6.9,1-11.3 C172.7,339.3,190.2,333.6,197.8,338.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M197.8,338.8c4,3.5,6.2,8.5,8.2,13.4c7.5,17.9,15.1,35.8,22.6,53.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M228.8,405.9c15.5,12.6,30.9,25.4,46.1,38.4"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M165.8,361c5,11.8,10.5,23.4,16.6,34.6c5.8,10.6,11.7,21.8,19.2,31.3c7,8.9,19.2,12.4,29.6,15.4 c12.9,3.7,26.1,6.3,38.7,11.1c0.5,0.2,0.6-0.6,0.2-0.7c-11.4-4.4-23.4-7-35.1-10.2c-11.7-3.2-25.6-6.7-33.3-16.8 c-7.2-9.4-13-20.2-18.7-30.6c-6.1-11.2-11.5-22.7-16.5-34.4C166.3,360.4,165.6,360.6,165.8,361L165.8,361z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M274.8,444.5c0.5,3.5-0.8,7.2-3.4,9.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M275.1,444.1c4.9-0.3,8.5-4.8,13.2-6.3c0.8-0.3,1.7-0.4,2.6-0.1c0.8,0.3,1.5,1.2,1.2,2"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M272.9,454.5c0.5,0,0.5-0.8,0-0.8C272.4,453.7,272.4,454.5,272.9,454.5L272.9,454.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M272.9,454.5c0.5,0,0.5-0.8,0-0.8C272.4,453.7,272.4,454.5,272.9,454.5L272.9,454.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M272.2,454.2c9.3,4.5,20.4,6.5,29.9,2.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M288.7,441.6c5.7,0.2,11.3-0.3,16.9-1.6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M292.4,446c4.5,0.1,8.8-1,12.8-3.3c0.4-0.2,0-0.9-0.4-0.6c-3.8,2.2-8,3.3-12.4,3.2 C292,445.2,292,446,292.4,446L292.4,446z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M293.2,450.4c4.8-0.2,9.1-1.9,12.6-5.1c0.4-0.3-0.2-0.9-0.5-0.5c-3.4,3-7.5,4.7-12.1,4.9 C292.8,449.7,292.8,450.5,293.2,450.4L293.2,450.4z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M296.6,455c3.4-0.8,6.5-2.5,9-4.9c0.4-0.3-0.2-0.9-0.5-0.5c-2.5,2.3-5.4,3.9-8.7,4.7 C295.9,454.4,296.1,455.1,296.6,455L296.6,455z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "head"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M162.7,294.1c1,0.3,2.6,0.9,4,2.2c2.3,2,3,4.5,3.7,7.1c0.8,2.8,1.4,5.1,0.8,7.9c-1.2,5.4-6.2,8.2-7.3,8.8 c0.1,0.3,0.8,2.7-0.6,4.1c-1.4,1.4-3.9,0.7-5.1,0.4c-4-1.1-6.9-4.5-8-6.9C147.5,311.7,152.3,301.7,162.7,294.1z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.866 -0.5 0.5 0.866 -127.8066 123.4854)",
  className: "st3",
  cx: 166.5,
  cy: 300.2,
  rx: 0.7,
  ry: 1.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M158.5,298.6c1-0.8,2.3-2,3.6-3.7c1.4-1.9,2.8-3.7,3-6.3c0.1-0.8,0.3-3.6-1.6-5.3c-1-0.8-2-1-2.5-1.1 c-4.8-0.7-10.7,5-11.5,5.8c-1.8-1.5-4.9-3.7-9.3-4.7c-2.6-0.6-5.2-1.3-8.1-0.2c-3.3,1.2-6.2,4.3-6.9,7.8c-0.7,3.6,1.4,5.1,0.1,8.3 c-0.5,1.2-1.1,1.8-3.7,4.1c-4.7,4.3-7,6.4-7.7,7.4c-2.5,4.1-2.4,8.4-2.4,10.8c0.1,4.7,1.6,8.2,2.3,9.7c1,2,3.7,7.5,10.1,10.6 c6.2,3,12,1.8,14.4,1.3c8.1-1.7,12.9-7,16.7-11.3c3-3.3,5.7-6.4,6.8-11.2c0.8-3.7,0.3-6.8-0.5-11.3 C160.6,304.9,159.5,301.2,158.5,298.6z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M163,293.8c4.5,1.5,6.9,6.6,7.8,11.2c0.4,2,0.7,4.2,0.4,6.2c-0.7,4.7-4.7,8.7-9.3,9.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M134.7,282.6c-3.3,0.3-6.3,2.2-8.1,5c-1.7,2.8-2,6.4-0.9,9.5c0.3,0.7,0.6,1.4,0.5,2.2 c-0.1,0.9-0.9,1.5-1.6,2.1c-3.4,2.5-7.2,4.7-9.7,8.2c-2.5,3.5-3.4,7.9-3.3,12.2c0.2,5.6,2.3,11.3,6,15.5s9.2,6.9,14.9,7 c7.6,0.1,14.5-4.4,20.1-9.6c2.9-2.7,5.5-5.7,7.1-9.3c1-2.2,1.5-4.6,1.7-7c0.4-3.8,0.3-7.7-0.5-11.5c-1.3-6.3-4.3-12.4-9-16.9 c-4.7-4.5-11-7.3-17.5-7.3"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M149.5,288.1c1.1-2.1,3.4-3.4,5.5-4.4c1.4-0.6,2.8-1.2,4.2-1.4c1.5-0.2,3.1,0.1,4.2,1.1 c1.2,1,1.7,2.6,1.7,4.2c0,1.6-0.6,3.1-1.3,4.5c-1.3,2.6-3.2,4.9-5.4,6.7"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M163.5,320c-0.2,1.4-0.4,2.7-0.6,4.1c-0.1,0.5,0.7,0.7,0.7,0.2c0.2-1.4,0.4-2.7,0.6-4.1 C164.3,319.7,163.6,319.5,163.5,320L163.5,320z"
})))));

function SvgHiring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.4 554.7",
    style: {
      enableBackground: "new 0 0 469.4 554.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiring);
export default __webpack_public_path__ + "static/media/hiring.981bf82a.svg";
export { ForwardRef as ReactComponent };